const examine = [
  {
    path: "/examine/manage",
    name: "examineManage",
    component: () => import("@/view/examine/manage"),
  },
  {
    path: "/examine/commit",
    name: "examineCommit",
    component: () => import("@/view/examine/commit"),
  },
  {
    path: "/examine/create",
    name: "examineCreate",
    component: () => import("@/view/examine/create"),
  },
];
export default examine;
